import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { KiMarkComponent } from '../ki-mark/ki-mark.component';

/** Kennzeichnung für Inhalte, die von der KI stammen (page-ki.jsx:45-51). */
@Component({
  selector: 'app-ki-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [KiMarkComponent, MatTooltip, TranslatePipe],
  template: `
    <span class="ki-badge" data-testid="ki-badge" [matTooltip]="'ki.badge.tooltip' | translate">
      <app-ki-mark [size]="15" />
      {{ label() || ('ki.badge.label' | translate) }}
    </span>
  `,
  styles: `
    :host {
      display: inline-block;
    }

    .ki-badge {
      display: inline-flex;
      align-items: center;
      gap: 0.375rem;
      padding: 0.125rem 0.5rem 0.125rem 0.1875rem;
      border: 1px solid var(--to-brand-border);
      border-radius: 999px;
      background: var(--to-brand-tint);
      color: var(--to-brand-deep);
      font-size: 0.6875rem;
      font-weight: 600;
      white-space: nowrap;
    }
  `,
})
export class KiBadgeComponent {
  readonly label = input<string>();
}
